import { useQuery, UseQueryResult } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

export interface KeywordInterface {
    keyword: string;
    formSubmissions: number;
    income: number;
    sales: number;
    cvRate: number;
}

interface KeywordReport {
    hasNextPage: boolean;
    report: KeywordInterface[];
}

export const useGetKeywordPerformance = (
  identifier: string,
  from: Dayjs | null,
  to: Dayjs | null,
  page: number,
  adCode?: string,
  search?: string,
): UseQueryResult<ApiResponse<KeywordReport>, ApiError<KeywordReport>> => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'page', page.toString());
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));
  appendQueryParamIfNotEmpty(queryParams, 'adCode', adCode ?? '');

  if (search != null) {
    appendQueryParamIfNotEmpty(queryParams, 'search', search);
  }

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`keywords_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}form-submission/keyword/count?${queryParams}`),
  );
};
